module.exports = __webpack_public_path__ + "img/banner-icon-good.d1f81f85.svg";